import React from 'react';
import './FormInput.css'

const FormInput = (props) => {
    return ( 
        <div className='FormInput'>
            <p className='FormInputLabel'>{props.FormInputLabel}</p>
            <input className='FInputField' placeholder={props.FormInputPlaceholder} type={props.FormInputType} />
        </div>
     );
}
 
export default FormInput;